export default __webpack_public_path__ + "static/media/startup_undraw.872e1c9a.svg";